import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { constant, debounce } from 'lodash';
import { TourService } from 'src/app/api/tourism/tour.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'component-search-tour',
  templateUrl: './search-tour.component.html',
  styleUrls: ['./search-tour.component.css']
})
export class SearchTourComponent implements OnInit {
  @ViewChild('searchInput') searchInput: any;
  @Output() selectedTourEvent = new EventEmitter<string>();
  @Input() classSize: string | null = null;

  data = [];
  keyword = 'description';
  isTypedSearch = false;
  classSearch:any;
  isAutocompleteDisabled = false; // Inicialmente habilitado

  constructor(private tourService: TourService) {}

  ngOnInit() {
    this.classSearch = this.classSize; 
  }

  debouncedSearchInput = debounce(event => this.getSearchTours(event), 250);

  getSearchTours(search_: any) {
    this.isTypedSearch = true;
    if (search_.length > 1) {
      let val_params = 'search=' + search_;
      this.tourService.search(val_params).subscribe({
        next: (data: any) => {
          this.data = data.results;
        }
      });
    } else {
      this.data = [];
    }
  }

  selectSearchTour(item: any) {
    // this.closedSearchPanel();    
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
      (<any>$('.autocomplete-container .not-found')).hide();
    }, 10);
    
    this.selectedTourEvent.emit(item);
    this.data = [];
    this.searchInput.clear();
    this.searchInput.focus();
  }

  closedSearchPanel(): void {
    this.data = [];
    // this.searchInput.clear();
    // this.searchInput.focus();
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  clearedInputSearch(): void {
    this.searchInput.focus();    
    this.data = [];
    this.isTypedSearch = false;
    setTimeout(() => {
      (<any>$('.autocomplete-overlay')).hide();
    }, 10);
  }

  focused() {
    this.searchInput.focus(); 
  }

  isDisabled() {
    this.searchInput.clear();
    this.isAutocompleteDisabled = true;
  }

  notDisabled() {
    this.isAutocompleteDisabled = false;
  }
}
